<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-8 col-12 offset-lg-4 offset-md-3 offset-sm-2 offset-0 mt-3">
                
                <div class="card">
                    <form class="card-body">
                        <!-- auth header logo -->
                        <app-header></app-header>

                        <h5 class="text-center text-dark-green mt-3">
                            <router-link :to="{ name: 'home' }">Reset Shop+ Passcode</router-link>
                        </h5>
                        
                        <!-- display alert message desktop view -->
                        <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-n3 mt-3 p-1`" role="alert">
                            <i class="fas fa-exclamation-circle"></i> {{ msg }}
                        </div>

                        <div class="mt-4">
                            <span class="font-weight-bold">New Passcode</span>
                            <input v-model="passcode" type="password" ref="passcode" class="form-control no-lines">
                        </div>
                        <div class="mt-3">
                            <span class="font-weight-bold">Repeat Passcode</span>
                            <input v-model="rePasscode" type="password" class="form-control no-lines">
                        </div>
                        <div class="text-center mt-3">
                            <button @click.prevent="shopResetPasscode" class="loadn btn btn-dark-green form-control">Change Passcode</button>
                        </div>
                        <div class="mt-4 text-center font-weight-bold">
                            <hr>
                            <p><router-link :to="{ name: 'lock-screen' }" class="text-dark-green">Unlock Shop+</router-link></p>
                            <p>New shopper? <router-link :to="{ name: 'signup' }" class="text-dark-green">Start here</router-link></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { webpageTitle } from '@/store/dry'

import Header from '../shared/Header.vue'
import LayoutAuth from '@/layouts/Auth.vue' 

export default {
    data() {
        return {
            passcode: '',
            rePasscode: '',
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(["resetPasscode"]),
        shopResetPasscode() {
            this.color = "danger"
            if(this.passcode === ''){ this.msg = "Enter a strong passcode"; return }
            if(this.passcode.length < 6){ this.msg = "Strong passcodes are more than 5 characters"; return }
            if(this.rePasscode === ''){ this.msg = "Repeat your strong passcode"; return }
            if(this.passcode !== this.rePasscode){ this.msg = "Passcodes does not match"; return }

            let userObj = {
                email: this.$route.params.email,
                confToken: this.$route.params.code,
                newPasscode: this.passcode
            }
            
            this.resetPasscode(userObj)
            .then((data) => {
                if(!data.error) {
                    this.color = "success"
                    this.passcode = ""
                    this.rePasscode = ""
                }
                this.msg = data.msg
            }).catch((e) => {
                this.msg = "We are having issues reaching our resoruces at this time. Check back soon."
            })
        }
    },
    components: {
        appHeader: Header
    },
    created() {
        webpageTitle(`Reset passcode`)
        this.$emit('update:layout', LayoutAuth);
    }
}
</script>
